var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMlog = function SvgIconMlog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 240,
    viewBox: "0 0 227 240",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.98981 178.215C0.967476 174.595 -0.0627188 170.509 0.00295456 166.367L1.40346 70.2095C1.46535 66.0667 2.62117 62.0133 4.75457 58.4571C6.88797 54.9008 9.92369 51.9673 13.5563 49.9516L97.7226 2.99829C101.351 0.980018 105.447 -0.053195 109.601 0.00210906C113.756 0.0574131 117.823 1.19919 121.396 3.31331L151.436 21.1432L133.269 43.7237L109.209 29.4432L30.0473 73.6045L28.7331 163.836L106.634 210.073L185.815 165.924L186.527 113.667L199.083 115.641L215.471 95.2317L214.462 169.293C214.4 173.43 213.249 177.479 211.124 181.034C209 184.589 205.976 187.526 202.355 189.551L118.143 236.504C114.504 238.513 110.402 239.541 106.242 239.486C102.082 239.431 98.0087 238.294 94.4247 236.189L11.5232 186.985C7.95524 184.859 5.01214 181.834 2.98981 178.215Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.909 29.5075L201.666 35.5435L215.501 70.0512L192.628 98.5227L155.867 92.4777L142.021 57.9414L164.909 29.5075Z",
    fill: "#0B679F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMlog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconMlog.96c3d598.svg";
export { ForwardRef as ReactComponent };